import { api } from 'data/api/api'

import { GetDigitalLabelArgs } from '../types/get-digital-label-args'
import { DigitalLabelResp } from '../types/digital-label-resp'

export const getDigitalLabel = ({ transactionId }: GetDigitalLabelArgs) =>
  api.get<DigitalLabelResp>(`/transactions/${transactionId}/shipment/digital_label`)
